import PropTypes from 'prop-types';

function IFDairyAndEggsActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M10.1517 3.78418L7.05609 7.34368L11.6625 8.34543L14.0642 4.63403L10.1517 3.78418Z"
                fill="#F4F0F2"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.05609 7.34375C7.05609 7.34375 2.70422 26.1266 2.85612 26.3524C2.95465 26.4961 4.03852 26.763 5.08132 27.1735C5.9558 27.5225 7.27368 27.8756 7.27368 27.8756L11.6625 8.36192L7.05609 7.34375Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6625 8.3623C11.6625 8.3623 18.1329 9.59397 18.2314 9.78693C18.3299 9.97989 14.6391 27.9293 14.6021 28.1058C14.4995 28.6149 14.3147 28.8941 12.808 28.7586C10.9505 28.5727 9.10437 28.2862 7.27783 27.9006L11.6625 8.3623Z"
                fill="#F4F0F2"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6625 8.36198L14.0642 4.66699C14.0642 4.66699 16.6055 5.12681 16.9381 5.29103C17.2706 5.45526 18.2313 9.80713 18.2313 9.80713L11.6625 8.36198Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.7159 4.08409C11.7898 3.75975 12.0362 2.65125 12.0362 2.65125C12.0362 2.65125 12.1511 1.89994 12.6397 2.01489L15.0496 2.5363C15.0496 2.5363 15.8461 2.64304 15.7476 3.09876C15.649 3.55447 15.337 4.88056 15.337 4.88056L11.7159 4.08409Z"
                fill="#547420"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.5924 26.3815C13.4059 24.6353 14.0982 18.3528 16.5924 17.694C19.9049 16.819 22.9916 21.6097 21.7798 24.5065C20.9955 26.3815 18.4915 27.4222 16.5924 26.3815Z"
                fill="#F6A685"
                stroke="#2D2D2D"
                strokeWidth="0.5"
            />
            <path
                d="M18.6989 21.6169C17.1128 18.3478 21.316 13.6274 23.7308 14.5351C26.9379 15.7404 26.6792 21.4336 24.0136 23.0931C22.2882 24.1673 19.6442 23.5653 18.6989 21.6169Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
            />
        </svg>
    );
}

export default IFDairyAndEggsActive;

IFDairyAndEggsActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFDairyAndEggsActive.defaultProps = {
    className: null,
    width: 28,
};
